import './CulturePalaceDetail.less'
import { useSearchParams } from 'react-router-dom'

const CulturePalaceDetail = () => {
  const [ params ] = useSearchParams()
  const prevId = params.getAll('id')[0]

  return (
    <div className='pg-culture-palace-detail'>
      <img className='detial-img' src={`https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/detail-${prevId}.png`} />
    </div>
  )
}

export default CulturePalaceDetail